import * as React from 'react';
import { useProgressBar } from '../../hooks/useProgressBar';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProgressBar(_ref) {
  var value = _ref.value,
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === void 0 ? 5 : _ref$maxValue,
    hideValue = _ref.hideValue;
  var _useProgressBar = useProgressBar({
      value: value,
      maxValue: maxValue
    }),
    fillWidthPercent = _useProgressBar.fillWidthPercent;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['line'],
      children: /*#__PURE__*/_jsx("div", {
        "data-testid": "progress",
        className: styles['progress'],
        style: {
          width: "".concat(fillWidthPercent, "%")
        }
      })
    }), !hideValue && /*#__PURE__*/_jsx("span", {
      "data-testid": "value",
      className: styles['value'],
      children: value.toFixed(1)
    })]
  });
}